import { render, staticRenderFns } from "./AddEditDialog.vue?vue&type=template&id=1c01a1f6&scoped=true&"
import script from "./AddEditDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDialog.vue?vue&type=style&index=0&id=1c01a1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01a1f6",
  null
  
)

export default component.exports